<div class="h-full flex flex-col" [class]="floatingPageClasses()">
  <h5
    class="text-neutral-900 font-semibold text-2xl"
    [class.mb-lg]="floating()">
    {{ 'job_titles_list_screen_title' | transloco }}
  </h5>

  <ng-template #tableActionSectionRef>
    <a
      class="flex items-center bg-primary-500 text-white font-medium text-sm py-sm px-2xl border-none rounded-md gap-sm"
      [routerLink]="[`${ADMIN_ROUTES.JOB_TITLES.FORM}` | tenantPath: 'admin']"
      id="job_titles_list_screen_new_job_title_button">
      <lib-add-icon [iconClass]="'size-5 text-white'" />

      <span class="hidden md:block">
        {{ 'job_titles_list_screen_new_job_title_button' | transloco }}
      </span>
    </a>
  </ng-template>

  <lib-filtered-table
    [tableId]="'job-titles'"
    [tableTitle]="'job_titles_list_screen_all_job_titles' | transloco"
    [dataSource]="jobTitleList()"
    [titleClass]="floating() ? '' : 'mb-2xl pb-lg'"
    [lastColumnAlignment]="'justify-end'"
    [meta]="meta()"
    [columns]="columns()"
    [isLoadingData]="isLoading()"
    [tableFilterTabs]="tableFilterTabs()"
    [(payload)]="payload"
    [tableActionSectionRef]="tableActionSectionRef"
    [isTableExportable]="false"
    [tableColumnTemplates]="[
      { template: number, identifier: '' },
      { template: name, identifier: '' },
      { template: assigned_users, identifier: '' },
      { template: status, identifier: JOB_TITLE_COLUMN_IDENTIFIERS.STATUS },
      { template: action, identifier: '' },
    ]"
    [applyOnStreamChanges]="getJobTitleList$"
    (streamSucceeds)="handleJobTitleListSuccess($event)"
    (handleApiCall)="getJobTitleList()"
    (handleViewIconClick)="viewJobTitleDetails($event)" />
</div>

<ng-template #number let-row>
  {{ row?.id }}
</ng-template>

<ng-template #name let-row>
  <h5 class="text-neutral-900 text-xs font-medium">
    {{ row?.name }}
  </h5>
</ng-template>

<ng-template #assigned_users let-row>
  <h5 class="text-neutral-900 text-xs font-medium">
    {{ row?.users_count }}
  </h5>
</ng-template>

<ng-template #status let-row>
  @if (row.state) {
    <lib-badge
      [label]="row.state.label"
      [badgeClass]="
        'px-sm border-none text-xs font-medium text-white ' +
        (row.state.value | userStatus)
      " />
  }
</ng-template>

<ng-template #action let-row>
  <lib-action-list
    [parentName]="'job-titles'"
    [menuItems]="actionMenuItems()"
    (menuToggled)="selectedJobTitle.set(row)"
    (itemClick)="handleAction($event, row)" />
</ng-template>

<ng-template #deactivate>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
      <lib-close-square-icon
        viewBox="0 0 30 30"
        width="27"
        height="27"
        iconClass="text-destructive-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'deactivate_job_title_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'deactivate_job_title_modal_description' | transloco }}
    <span class="font-medium text-primary-500">
      {{ 'deactivate_job_title_modal_highlighted_description' | transloco }}
    </span>
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [class.opacity-30]="isJobTitleStateLoading()"
      [disabled]="isJobTitleStateLoading()"
      (click)="deactivateJobTitle()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'deactivate_job_title_modal_deactivate_job_title_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'deactivate_job_title_modal_no_keep_it_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #activate>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-primary-50 p-sm rounded-full mb-xl img-width-container">
      <lib-tick-square-icon iconClass="size-8 text-primary-500" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'activate_job_title_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'activate_job_title_modal_description' | transloco }}
    <span class="font-medium text-primary-500 block">
      {{ 'activate_job_title_modal_highlighted_description' | transloco }}
    </span>
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [disabled]="isJobTitleStateLoading()"
      (click)="activateJobTitle()"
      class="bg-primary-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'activate_job_title_modal_activate_job_title_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'activate_job_title_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>

<ng-template #deleteRecord>
  <div class="text-center">
    <div
      class="inline-flex justify-center items-center bg-destructive-50 p-sm rounded-full mb-xl w-[4rem] h-[4rem]">
      <lib-delete-icon [iconClass]="'size-8 text-destructive-500'" />
    </div>
  </div>

  <p class="text-lg text-center font-medium mb-sm">
    {{ 'delete_job_title_modal_title' | transloco }}
  </p>

  <p class="text-sm text-neutral-500 text-center mb-4xl">
    {{ 'delete_job_title_modal_description' | transloco }}
  </p>

  <div class="flex flex-col gap-md text-base font-medium">
    <button
      [class.opacity-30]="isJobTitleStateLoading()"
      [disabled]="isJobTitleStateLoading()"
      (click)="deleteJobTitle()"
      class="bg-destructive-500 py-sm rounded-md text-white text-base cursor-pointer">
      {{ 'delete_job_title_modal_delete_job_title_button' | transloco }}
    </button>

    <button
      (click)="closeModal()"
      class="text-neutral-700 bg-white border border-neutral-300 py-sm rounded-md text-base cursor-pointer">
      {{ 'delete_job_title_modal_cancel_button' | transloco }}
    </button>
  </div>
</ng-template>
